import { useId } from 'react'

import { CheckBox } from '@modules/shadcn/ui/CheckBox/CheckBox'

interface OptionPanelProps {
  unifyColor: boolean
  onUnifyColorChange: (checked: boolean) => void
}

/**
 * AIカラーシミュレーション編集モードの「オプション」セクション。
 * 現状は「実行時に単色でカラー変更する」のみ。常時表示・枠全体クリックで切替。
 */
export const OptionPanel: React.FC<OptionPanelProps> = ({ unifyColor, onUnifyColorChange }) => {
  const checkboxId = useId()
  return (
    <div>
      <h2 className="mb-2 text-xs font-bold tracking-[-0.02em] text-[#09090B]">オプション</h2>
      <label className="block cursor-pointer space-y-2" htmlFor={checkboxId}>
        <div className="flex items-center justify-between gap-3 rounded-md border border-[#E4E4E7] bg-white p-3 hover:bg-[#FAFAFA]">
          <p className="text-sm font-medium text-[#09090B]">実行時に単色でカラー変更する</p>
          <CheckBox
            checked={unifyColor}
            id={checkboxId}
            onCheckedChange={(checked: boolean) => onUnifyColorChange(checked === true)}
          />
        </div>
        <p className="text-xs text-[#09090B]">実行時に外壁・屋根を1つの色でまとめて変更します。</p>
      </label>
    </div>
  )
}
